var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePopup',{on:{"close":_vm.close},model:{value:(_vm.shown),callback:function ($$v) {_vm.shown=$$v},expression:"shown"}},[(_vm.$vuetify.breakpoint.width <= 1400)?_c('Cart',{staticClass:"popup-order-cart",on:{"empty":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }